import React, { useMemo } from "react";
import { Alert } from "@mui/material";

// Aviso del plazo de corte para contratistas y supervisores
// (payment-monthly-cutoff, D5). `cutoff` es el resultado de usePaymentCutoff
// en la vista que lo monta (así la configuración se lee una sola vez por
// vista); `natures` son las naturalezas de los contratos a la vista y `role`
// es "contractor" o "supervisor". Con varias naturalezas el aviso muestra el
// corte más próximo. `info` en el periodo de aviso, `warning` con la ventana
// cerrada; nada fuera de esos periodos ni con el interruptor apagado.
// `subject` es "acta" (por defecto) o "factura" para las solicitudes jurídicas.
export default function PaymentCutoffNotice({ cutoff, natures, role, subject, sx }) {
  const list = useMemo(
    () => (Array.isArray(natures) ? natures : [natures]),
    [natures]
  );
  const notice = cutoff && cutoff.loaded ? cutoff.notice(list, role, { subject }) : null;
  if (!notice) return null;
  return (
    <Alert severity={notice.severity} sx={{ my: 2, ...(sx || {}) }}>
      {notice.message}
    </Alert>
  );
}
